import abTranslate from 'ab-translate/dist/src/abTranslate-runtime';
import { get } from 'lodash';
let allTranslations = get(global, '__Locale.translations', {});
let experiments = get(global, '__EXPERIMENTS__', null);
let abTranslations = abTranslate(experiments, allTranslations);
export const translations = {
  getAll: () => abTranslations,
  get: id => get(abTranslations, [id]),
  set: messages => {
    allTranslations = messages;
    abTranslations = abTranslate(experiments, allTranslations);
  },
  setExperiments: specs => {
    experiments = specs;
    abTranslations = abTranslate(experiments, allTranslations);
  }
};
//# sourceMappingURL=translations.js.map